import { render, staticRenderFns } from "./DigitalPlatformDashboard.vue?vue&type=template&id=5990d4bc&scoped=true&"
import script from "./DigitalPlatformDashboard.vue?vue&type=script&lang=js&"
export * from "./DigitalPlatformDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DigitalPlatformDashboard.vue?vue&type=style&index=0&id=5990d4bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5990d4bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCardTitle,VSkeletonLoader,VSnackbar})
